<template>
    <b-row>
        <b-col cols="12">
            <h4 class="mb-3">
                {{ $t('general.abono', { abono: teatro.texto_abono.charAt(0).toUpperCase() + teatro.texto_abono.slice(1) }) }} {{ index + 1 }}
            </h4>
        </b-col>
        <b-col cols="12">
            <b-row>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.name"
                        :id="'nombre-' + index"
                        rules="required"
                        :label="$t('formularios.nombre')"
                        :name="$t('formularios.nombre')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4" v-if="abono.identification?.type !== 'NIF'">
                    <FormInput
                        v-model="abono.lastName"
                        rules="required"
                        :id="'apellidos-' + index"
                        :label="$t('formularios.apellidos')"
                        :name="$t('formularios.apellidos')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider name="genero" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>{{ $t('formularios.genero') }}</label>
                            <multiselect
                                v-model="abono.gender_object"
                                label="name"
                                track-by="id"
                                class="custom-multiselect"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                :id="'genero-' + index"
                                :placeholder="$t('formularios.genero')"
                                :options="generos"
                                @select="formatGender"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" >
                                {{ errors[0] }}
                            </span>
                        </div>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <DocumentoTipo
                        :value="abono.identification.type"
                        :index="index"
                        @input="val => { abono.identification.type = val; }"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <DocumentoValor
                        :type="abono.identification.type"
                        :value="abono.identification.value"
                        :index="index"
                        @input="val => { abono.identification.value = val; }"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Paises
                            ref="paises"
                            :pais="pais?.iso3 ? pais : null"
                            :desactivar="false"
                            @paisesCargados="onPaisesCargados"
                            @rellenarPais="rellenarPais"
                            @selected="opt => { pais = opt; abono.address.country = opt.iso3; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Provincias
                            ref="provincias"
                            :desactivar="false"
                            :pais="pais.id"
                            :provincia="provincia"
                            @provinciasCargadas="onProvinciasCargadas"
                            @selected="opt => { provincia = opt; abono.address.state = opt.nombre; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Locations
                            :localidad="localidad"
                            :desactivar="false"
                            :provincia="provincia"
                            @localidadesCargadas="onLocalidadesCargadas"
                            @selected="opt => { abono.address.city = opt.nombre; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.address.zipCode"
                        rules="required"
                        :id="'cp-' + index"
                        :label="$t('formularios.cp')"
                        :name="$t('formularios.cp')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.address.streetLine1"
                        rules="required"
                        :id="'direccion-' + index"
                        :label="$t('formularios.domicilio')"
                        :name="$t('formularios.domicilio')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4" v-if="abono.identification?.type !== 'NIF'">
                    <FormInput
                        v-model="abono.birthday"
                        rules="required"
                        :id="'fecha-nacimiento-' + index"
                        type="date"
                        :label="$t('formularios.nacimiento')"
                        :name="$t('formularios.nacimiento')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.email"
                        rules="required"
                        :vid="'confirmation-' + index"
                        :id="'email-' + index"
                        type="email"
                        :label="$t('formularios.email')"
                        :name="$t('formularios.email')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.email_confirm"
                        :id="'email-confirm-' + index"
                        type="email"
                        :rules="'required|confirmed_ci:@confirmation-' + index"
                        :label="$t('formularios.confirmar_email')"
                        :name="$t('formularios.confirmar_email')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <label :for="'telefono-' + index">{{ $t('formularios.telefono') }}</label>
                        <PhoneInput
                            :name="'telefono-' + index"
                            :phone="abono.phone ?? null"
                            :required="true"
                            :error_telefono="abono.error_telefono"
                            @setNumber="(number) => abono.phone = number"
                            @validNumber="(valid) => abono.isValidNumber = valid"
                        />
                    </div>
                </b-col>
                <b-col cols="12" class="mt-3" v-if="abono.identification?.type !== 'NIF' && esMenorDeEdad">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" :id="'no_mi_identificacion-' + index" v-model="abono.hasNotOwnIdentification"/>
                        <label :for="'no_mi_identificacion-' + index" class="custom-control-label h5 mt-1">
                            {{ $t('eventos_sga.checkBox_identificacion') }}
                        </label>
                    </div>
                </b-col>
                <b-col cols="12" class="m-3">
                    <hr/>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script setup>
    import { ref, computed, getCurrentInstance } from 'vue';
    import Provincias from "../../../../common/forms/Provincias";
    import Locations from "../../../../common/forms/Locations";
    import Paises from "../../../../common/forms/Paises";
    import PhoneInput from '@/components/common/PhoneInput';
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";
    import { useEsMenorDeEdad } from "@/composables/common/useEsMenorDeEdad";
    import store from '@/store';

    const props = defineProps({
        datosAbonosLocal: {
            type: Object,
            required: true
        },
        generos: {
            type: Array,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    });

    const emit = defineEmits(['update:datosAbonosLocal']);


    const provincia = ref(null);
    const localidad = ref(null);
    const pais = ref({ id: 0 });

    const abono = computed({
        get: () => props.datosAbonosLocal,
        set: value => emit('update:datosAbonosLocal', value)
    });

    const teatro = computed(() => store.getters.getTeatro);

    const { isMinor: esMenorDeEdad } = useEsMenorDeEdad(computed(() => props.datosAbonosLocal.birthday));

    const rellenarPais = paisSeleccionado => {
        abono.value.address.country = paisSeleccionado.iso3;
    };

    const onPaisesCargados = paises => {
        if (abono.value.address.country) {
            const encontrado = paises.find(p => p.iso3 === abono.value.address.country);
            pais.value = encontrado || { id: 0 };
        }
    };

    const onProvinciasCargadas = provincias => {
        if (abono.value.address.state) {
            const encontrado = provincias.find(p => p.nombre === abono.value.address.state);
            provincia.value = encontrado || null;
        }
    };

    const onLocalidadesCargadas = localidades => {
        if (abono.value.address.city) {
            const encontrado = localidades.find(l => l.nombre === abono.value.address.city);
            localidad.value = encontrado || null;
        }
    };

    const formatGender = option => {
        switch (option.name) {
            case 'Hombre':
                abono.value.gender = 'MALE';
                break;
            case 'Mujer':
                abono.value.gender = 'FEMALE';
                break;
            default:
                abono.value.gender = 'OTHER';
                break;
        }
    };

    if (teatro.value.provincia) {
        provincia.value = teatro.value.provincia;
    }
</script>
